import { Search } from "lucide-react";
import { useState } from "react";

export default function SearchBar({ onSearch }) {
  const [query, setQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    onSearch(value);
  };

  return (
    <div style={{
      position: 'relative',
      width: '100%',
      maxWidth: '420px',
      margin: '48px auto 24px',
    }}>
      <div style={{
        position: 'relative',
        borderRadius: '9999px',
        background: 'var(--bg-card)',
        border: `1px solid ${isFocused ? 'rgba(var(--accent-primary-rgb), 0.3)' : 'var(--border-glass)'}`,
        boxShadow: isFocused ? '0 0 24px rgba(var(--accent-primary-rgb), 0.08)' : 'none',
        transition: 'all 0.3s ease',
        overflow: 'hidden',
      }}>
        {/* Gradient top accent when focused */}
        {isFocused && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: '20%',
            right: '20%', 
            height: '1px',
            background: 'linear-gradient(90deg, transparent, var(--accent-cyan), transparent)',
          }} />
        )}
        <Search
          style={{
            position: 'absolute',
            left: '18px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '16px',
            height: '16px',
            color: isFocused ? 'var(--accent-cyan)' : 'var(--text-muted)',
            transition: 'color 0.3s ease',
          }}
        />
        <input
          style={{
            width: '100%',
            padding: '14px 20px 14px 46px',
            background: 'transparent',
            border: 'none',
            outline: 'none',
            color: 'var(--text-primary)',
            fontSize: '0.9rem',
            fontFamily: 'var(--font-body)',
          }}
          placeholder="Search professionals, projects..."
          type="search"
          value={query}
          onChange={handleInputChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />
      </div>
    </div>
  );
}